var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"main"},[_vm._v(" 本站由 腾讯云/CentOS/Apache/Vue/Webpack/iView 提供技术支持 ")])])}]

export { render, staticRenderFns }